import React, { Component } from "react";
import RootProfileImgUpload from "container/upload/RootProfileImgUpload";
import GatewayCheckpoint from "container/common/GatewayCheckpoint";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";
import { getEssentialUrl } from "lib/urlQueryParser";

class UploadProfileImgPage extends Component {
  render() {
    return (
      <AppUpdateCheckpoint>
        <GatewayCheckpoint
          type={"replace"}
          url={getEssentialUrl({ type: "opening" })()}
        >
          <RootProfileImgUpload />
        </GatewayCheckpoint>
      </AppUpdateCheckpoint>
    );
  }
}

export default UploadProfileImgPage;
